module.exports = __webpack_public_path__ + "static/media/calendar.79284093.svg";